import type { CarTireWearRecord, TireSeason } from '@navio/nsdk';
import type { NoddiColumnDef } from 'noddi-ui-web';
import { commonTexts } from 'noddi-util';
import { CarSeasonTiresCell } from './CarSeasonTiresCell';
import { NavioTireSeasonChip } from './NavioTireSeasonChip';

// The chip says "Summer tires" by default; the column only needs the season.
const SEASON_HEADER_TEXTS = {
  summerTires: commonTexts.summer,
  winterTires: commonTexts.winter,
  allSeasonTires: commonTexts.allSeason
};

/**
 * One column per season for any car list that loads `tireWear`. Every season sits
 * on the row at once, because a toggle would hide half the answer to "do these
 * tires need replacing?" and make rows mean different things per car.
 *
 * Separate columns rather than a "Tires" group with sub-labels: the table renders
 * a single header row of fixed height, so a stacked header gets clipped. The mm
 * unit lives in the column description instead of the label.
 */
export const getSeasonTireColumns = <TData extends { tireWear?: CarTireWearRecord | null }>(
  seasons: readonly TireSeason[]
): NoddiColumnDef<TData>[] =>
  seasons.map((season) => ({
    id: `treadDepth-${season}`,
    header: () => <NavioTireSeasonChip season={season} size='sm' translations={SEASON_HEADER_TEXTS} />,
    cell: ({ row }) => <CarSeasonTiresCell tireWear={row.original.tireWear} season={season} />,
    meta: { description: 'Latest measured tread depth in mm per wheel, and the registered tire size per axle' },
    size: 190
  }));
